import { render, staticRenderFns } from "./ExchangeListItem.vue?vue&type=template&id=5ebbd024&scoped=true&"
import script from "./ExchangeListItem.vue?vue&type=script&lang=js&"
export * from "./ExchangeListItem.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeListItem.vue?vue&type=style&index=0&id=5ebbd024&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebbd024",
  null
  
)

export default component.exports